import { Box, Fade, Popover, Typography } from '@material-ui/core'
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline'
import PersonOutlineIcon from '@material-ui/icons/PersonOutline'
import { FC, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Button from '@/components/button'
import { routes } from '@/routes/config'

import LeaveModal from './leave-modal'
import { useStyles } from './styles'

type AccountModalProps = {
  user: {
    name: string
    email: string
  }
}

const AccountModal: FC<AccountModalProps> = ({ user }) => {
  const classes = useStyles()
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  function handleClose() {
    setAnchorEl(null)
  }

  function handleEditAccountInfoClick() {
    handleClose()
    navigate(routes.EditAccount())
  }

  function handleMembersClick() {
    handleClose()
    navigate(routes.Members())
  }

  function getUsernameInitials(fullName: string): string {
    const separatedName = fullName.split(' ')
    const firstName = separatedName.at(0)
    const lastName = separatedName.at(-1)
    const initials = [firstName, lastName].map((name) =>
      name?.at(0)?.toUpperCase(),
    )
    return initials.join('')
  }
  return (
    <>
      <Button
        className={classes.openModalButton}
        labelOnly
        onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
          setAnchorEl(e.currentTarget)
        }
      >
        {getUsernameInitials(user.name)}
      </Button>
      <Popover
        className={classes.modal}
        anchorEl={anchorEl}
        classes={{ paper: classes.paper }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{ vertical: -7, horizontal: 280 }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        TransitionComponent={Fade}
        transitionDuration={300}
      >
        <Box className={classes.email}>
          <Typography variant={'body1'}>{user.name}</Typography>
          <Typography variant={'subtitle1'}>{user.email}</Typography>
          <Button
            className={classes.iconButton}
            labelOnly
            onClick={handleEditAccountInfoClick}
          >
            <PersonOutlineIcon />
            <Typography variant={'body1'}>Gerenciar conta</Typography>
          </Button>
          <Button
            className={classes.iconButton}
            labelOnly
            onClick={handleMembersClick}
          >
            <PeopleOutlineIcon />
            <Typography variant={'body1'}>Membros</Typography>
          </Button>
        </Box>
        <LeaveModal />
      </Popover>
    </>
  )
}
export default AccountModal
